import { useSelector } from "react-redux";
import RandomizeSubjectACT from "./act_ais";
import RandomizeSubjectRIC from "./ric";
import RandomizeSubjectICH from "./act_ich";

export default function RandomizeSubject() {
  const study_id = useSelector((state) => state.user.userData.active_study_id);
  if (study_id === 1) {
    return <RandomizeSubjectACT />;
  } else if (study_id === 4) {
    return <RandomizeSubjectRIC />;
  } else if (study_id === 7) {
    return <RandomizeSubjectICH />;
  }
}
